/* tslint:disable */
/* eslint-disable */
/**
 * CMA API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AgentDto
 */
export interface AgentDto {
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof AgentDto
     */
    id: number;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    title?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    license?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    brokerage?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    brokerageLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    phone?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    headshotUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    website?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    sourceId?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    teamName?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    teamLogo?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    instagramUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    facebookUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    xUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    youtubeUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof AgentDto
     */
    linkedInUrl?: string;
}

/**
 * Check if a given object implements the AgentDto interface.
 */
export function instanceOfAgentDto(value: object): value is AgentDto {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function AgentDtoFromJSON(json: any): AgentDto {
    return AgentDtoFromJSONTyped(json, false);
}

export function AgentDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AgentDto {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'license': json['license'] == null ? undefined : json['license'],
        'brokerage': json['brokerage'] == null ? undefined : json['brokerage'],
        'brokerageLogo': json['brokerageLogo'] == null ? undefined : json['brokerageLogo'],
        'phone': json['phone'] == null ? undefined : json['phone'],
        'headshotUrl': json['headshotUrl'] == null ? undefined : json['headshotUrl'],
        'website': json['website'] == null ? undefined : json['website'],
        'sourceId': json['sourceId'] == null ? undefined : json['sourceId'],
        'email': json['email'] == null ? undefined : json['email'],
        'state': json['state'] == null ? undefined : json['state'],
        'teamName': json['teamName'] == null ? undefined : json['teamName'],
        'teamLogo': json['teamLogo'] == null ? undefined : json['teamLogo'],
        'instagramUrl': json['instagramUrl'] == null ? undefined : json['instagramUrl'],
        'facebookUrl': json['facebookUrl'] == null ? undefined : json['facebookUrl'],
        'xUrl': json['xUrl'] == null ? undefined : json['xUrl'],
        'youtubeUrl': json['youtubeUrl'] == null ? undefined : json['youtubeUrl'],
        'linkedInUrl': json['linkedInUrl'] == null ? undefined : json['linkedInUrl'],
    };
}

export function AgentDtoToJSON(json: any): AgentDto {
    return AgentDtoToJSONTyped(json, false);
}

export function AgentDtoToJSONTyped(value?: AgentDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
        'title': value['title'],
        'license': value['license'],
        'brokerage': value['brokerage'],
        'brokerageLogo': value['brokerageLogo'],
        'phone': value['phone'],
        'headshotUrl': value['headshotUrl'],
        'website': value['website'],
        'sourceId': value['sourceId'],
        'email': value['email'],
        'state': value['state'],
        'teamName': value['teamName'],
        'teamLogo': value['teamLogo'],
        'instagramUrl': value['instagramUrl'],
        'facebookUrl': value['facebookUrl'],
        'xUrl': value['xUrl'],
        'youtubeUrl': value['youtubeUrl'],
        'linkedInUrl': value['linkedInUrl'],
    };
}

